import React, { useState } from "react";
import { Container, Row, Col, Image, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ShitCoin from "../../assets/images/shitcoin-logo.png";
import Arrow from "../../assets/images/arrow-icon.svg";
import ExchangeCard from "../../assets/images/exchange-card.png";
import CopyIcon from "../../assets/images/copy-icon.svg";
import "../shitcoin-chain/ShitcoinChain.css";
function RewardsOptions() {
  let [approve, setApproved] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="banner wallet-banner">
      <Container fluid className="custom-container">
        <Row className="align-items-center">
          <Col lg={5}>
            <div className="shit-coin-logo">
              <Image src={ShitCoin} fluid />
            </div>
          </Col>
          <Col lg={1}></Col>

          <Col lg={6}>
            <div className="content-wrapper">
              {!approve ? (
                <>
                  <Dropdown className="reward-dropdown">
                    <Dropdown.Toggle variant="none" className="text-center">
                      Select a Shitcoin of your choice
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>18Digits (18D)</Dropdown.Item>
                      <Dropdown.Item>CannabisCoin (CANN)</Dropdown.Item>
                      <Dropdown.Item>Universa (UTNP)</Dropdown.Item>
                      <Dropdown.Item>Denarius (DEN)</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <div className="selected-coin d-flex">
                    <div className="coin-name w-50">18Digits (18D)</div>
                    <form className="position-relative w-50">
                      <input className="coin-reward-value h-100 border-0" type={"number"} placeholder="95000"/>
                      <span className="max">Max</span>
                    </form>
                  </div>
                  <div className="arrow-bottom text-center">
                    <Image src={Arrow} fluid />
                  </div>
                  <Dropdown className="reward-dropdown">
                    <Dropdown.Toggle
                      variant="none"
                      className="text-center mb-0"
                    >
                      Select your reward
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>Reward #1</Dropdown.Item>
                      <Dropdown.Item>Reward #2</Dropdown.Item>
                      <Dropdown.Item>Reward #3</Dropdown.Item>
                      <Dropdown.Item>Reward #4</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <div className="transection-btn-wrapper text-center">
                    <button
                      className="transection-btn active"
                      onClick={() => setApproved(true)}
                    >
                      Approve Transaction
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="exchange-card position-relative">
                    <Image src={ExchangeCard} fluid />
                    <span className="promo-code">13K56HS12sn</span>
                  </div>
                  <div className="text-center">
                    <button className="copy-link bg-transparent border-0 p-0">
                      <Image className="me-2" src={CopyIcon} fluid />
                      Copy Code
                    </button>
                  </div>
                  <div className="reward-wrapper text-center">
                    <button className="reward-btn">Use Your Reward</button>
                  </div>
                </>
              )}
            </div>
          </Col>
        </Row>
      </Container>
      <button
        className="back-btn bg-transparent border-0 d-flex align-items-center"
        onClick={() => navigate(-1)}
      >
        <Image className="me-1" src={Arrow} fluid />
        Back
      </button>
    </div>
  );
}
export default RewardsOptions;
